import axiosConfig from "./axiosConfig";

export interface InvoiceDiscrepancy {
  field: string;
  issue: "mismatch" | "not_found_in_file";
  expected: number | null;
  extracted: number | null;
  difference?: number;
}

export interface InvoiceValidationResponse {
  isValid: boolean;
  isOO: boolean;
  expected: Record<string, number | string | null>;
  extracted: Record<string, number | null>;
  discrepancies: InvoiceDiscrepancy[];
}

const getSiteInvoiceValidation = async (
  authToken: string,
  siteId: string,
  fileGuid: string,
  month: string
): Promise<InvoiceValidationResponse> => {
  const { data } = await axiosConfig.get(
    `/site/${siteId}/invoice/validate?fileGuid=${encodeURIComponent(fileGuid)}&month=${encodeURIComponent(month)}`,
    {
      headers: {
        Authorization: `Bearer ${authToken}`,
      },
    }
  );
  return data;
};

export default getSiteInvoiceValidation;
